import Vue from 'vue'
import VueSilentbox from 'vue-silentbox'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import Quiz from '../components/Quiz'
import Results from '../components/Results'
import Cookies from '../components/Cookies'
import GeneralConditions from '../components/GeneralConditions'

Vue.use(VueRouter);
Vue.use(VueSilentbox);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/start-test',
      name: 'Quiz',
      component: Quiz,
      props: (route) => ({
        debug: route.query.debug,
        step: route.query.step,
        grade: route.query.grade,
        email: route.query.email,
      })
    },
    {
      // The token is a required path segment, not a query string: an old
      // link without one no longer resolves to this route at all, and a
      // result link is never split across a path/query boundary that
      // referrer stripping tools treat differently. This route never
      // touches Firestore directly, not even to check whether a
      // submission exists; that happens exclusively through the secured
      // getResult callable, from Results.vue itself.
      path: '/results/:uid/:token',
      name: 'Results',
      component: Results,
    },
    {
      // Links issued before secret tokens were introduced only contain the
      // document id. Keep them on the result surface so the visitor gets a
      // clear invalid-link message, without sending that id to Firestore or
      // the getResult callable.
      path: '/results/:uid',
      name: 'LegacyResults',
      component: Results,
    },
    {
      path: '/cookies',
      name: 'Cookies',
      component: Cookies
    },
    {
      path: '/general-conditions',
      name: 'GeneralConditions',
      component: GeneralConditions
    },
    {
      path: '*',
      redirect: '/',
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js